import  { initReactQueryAuth }  from 'react-query-auth';
import { useMutation } from 'react-query';
import {
  loginWithEmailAndPassword,
  //getUser,
  registerWithEmailAndPassword,
  resetPassword,
  verifyOTPWithOTP,
  forgetPasswordWithEmail,
  UserResponse,
  LoginCredentialsDTO,
  forgetPasswordCredentialsDTO,
  verifyOTPCredentialsDTO,
  resetPasswordCredentialsDTO,
  RegisterCredentialsDTO,
  AuthUser,
  getUser,
} from '@/features/auth';
import storage from '../utils/storage';
import { CircularProgress } from '@mui/material';
import '../App.css';



async function handleUserResponse(data) {
  console.log(data.data , "dasta");

  console.log("token", data.token , "data", data.userId);
  let userData = {
    "firstName":data.firstName,
    "lastName":data.firstName,
    "email":data.email,
    "nickname":data.nickName,
    "id":data.userId
  }
  //loadUser(userData)
  storage.setToken(data.data.token);
  storage.setUserId(data.data.userId)
  return userData;
}



async function loadUser() {
  if (storage.getToken()) {
    const data = await getUser();
    return data;
  }
  return null;
}



async function loginFn(data: LoginCredentialsDTO) {
  const response = await loginWithEmailAndPassword(data);
  const user = await handleUserResponse(response);
  console.log(response , "response");
  return user;
}

async function verifyFn(data: LoginCredentialsDTO) {
  const response = await loginWithEmailAndPassword(data);
  return response;
}


async function handleregisterFnResponse(data) {
  console.log("Received token:", data.token);
  console.log("User ID:", data.id);

  const userData = {
    id: data.id,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    nickname: data.nickName,
    userType: data.userType,
  };

  storage.setToken(data.token);
  storage.setUserId(data.id);

  return userData;
}
async function registerFn(data: RegisterCredentialsDTO): Promise<AuthUser> {
  const response = await registerWithEmailAndPassword(data);
  console.log(response, "response");

  const user = await handleregisterFnResponse(response);

  return {
    id: user.id,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
  };
}



async function verifyOTPFn(data: verifyOTPCredentialsDTO) {
  const response = await verifyOTPWithOTP (data);
  return response;
}


async function logoutFn() {
  storage.clearToken();
  storage.clearUserId();
  storage.cleartUserPassword();
  storage.clearRemeberMe();
  window.location.assign(window.location.origin as unknown as string);
}

const authConfig = {
  loadUser,
  loginFn,
  registerFn,
  verifyFn,
  verifyOTPFn,
  logoutFn,
  LoaderComponent() {
    return (
      <div className='loaderMain' style = {{display:"flex" , justifyContent:"center", alignItems:"center", height:"100vh"}}>
      <CircularProgress size={80}/>
      </div>
    );
  },
};





export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  unknown,
  LoginCredentialsDTO,
  RegisterCredentialsDTO
>(authConfig);


